export const getServices = (state) => state.servicesSante.data
export const getServiceProfil = (state) => state.servicesSante.dataProfil
export const isDemandesProfilLoading = (state) => state.servicesSante.loadingProfil
export const isDemandesLoading = (state) => state.servicesSante.loading
export const getExpirationDate = (state) => state.servicesSante.expirationDate
export const getExpirationDateProfil = (state) => state.servicesSante.expirationDateProfil
